/* @generated from adl module ferovinum.app.views */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './db';
import * as ferovinum_app_types from './types';
import * as ferovinum_app_uploads from './uploads';
import * as sys_types from './../../sys/types';

/**
 * For endpoints that return CSV data - it's a string but it's a string of CSV data based on the type T.
 */
export type CSVData<_T> = string;

const CSVData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[{"value":"For endpoints that return CSV data - it's a string but it's a string of CSV data based on the type T.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"type_","value":{"typeParams":["T"],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"CSVData","version":{"kind":"nothing"}}};

export const snCSVData: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"CSVData"};

export function texprCSVData<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<CSVData<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "ferovinum.app.views",name : "CSVData"}}, parameters : [texprT.value]}};
}

export type PurchasedStockCSV = CSVData<PurchasedStockView>;

const PurchasedStockCSV_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"CSVData"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"PurchasedStockView"}},"parameters":[]}]}}},"name":"PurchasedStockCSV","version":{"kind":"nothing"}}};

export const snPurchasedStockCSV: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"PurchasedStockCSV"};

export function texprPurchasedStockCSV(): ADL.ATypeExpr<PurchasedStockCSV> {
  return {value : {typeRef : {kind: "reference", value : snPurchasedStockCSV}, parameters : []}};
}

/**
 * Purchased Stock.  The rows of PurchasedStockView are DealLeg with relevant fields joined in from Deal, Product, Organisation.
 */
export interface PurchasedStockView {
  /**
   * Leg Identifier (DealLeg->legIdentifier)
   */
  legIdentifier: common_strings.StringNE;
  /**
   * Deal Number (Deal->dealNumber)
   */
  dealNumber: common_strings.StringNE;
  /**
   * Deal Date (Deal->dealDate)
   */
  dealDate: common.LocalDate;
  /**
   * Payment Date (DealLeg->paymentDate)
   */
  paymentDate: common.LocalDate;
  /**
   * Delivery Date (DealLeg->deliveryDate)
   */
  deliveryDate: (common.LocalDate|null);
  /**
   * Storage Loc/Acct (DealLeg->StorageLocation->locationName)
   */
  locationName: common_strings.StringNE;
  /**
   * Counterparty  (Deal->Organisation->businessName)
   */
  counterparty: common_strings.StringNE;
  /**
   * Product Code (DealLeg->Product->code)
   */
  code: common_strings.StringNE;
  /**
   * Producer (DealLeg->Product->producerName)
   */
  producerName: common_strings.StringNE;
  /**
   * Product (DealLeg->Product->name)
   */
  name: common_strings.StringNE;
  /**
   * Vintage / Distillation Date (DealLeg->Product->productDate)
   */
  productDate: ferovinum_app_db.ProductDate;
  /**
   * Vessel information (DealLeg->Product->vesselInfo)
   */
  vesselSize: (ferovinum_app_db.VesselSize|null);
  /**
   * Unit Type (DealLeg->Product->unitType)
   */
  unitType: ferovinum_app_db.UnitType;
  /**
   * Country of Origin (DealLeg->Product->countryOfOrigin)
   */
  countryOfOrigin: common.Country;
  /**
   * Region / Appellation (DealLeg->Product->regionOrigin)
   */
  regionOrigin: string;
  /**
   * ABV (%) (DealLeg->Product->alcoholByVolumePc)
   */
  alcoholByVolumePc: number;
  /**
   * Type (DealLeg->Product->productType)
   */
  productType: ferovinum_app_db.ProductType;
  /**
   * Duty Paid / In-Bond (DealLeg.dutyPaid)
   */
  dutyPaid: boolean;
  /**
   * Number of Units (DealLeg.numberOfUnits)
   */
  numberOfUnits: ferovinum_app_db.NumberOfUnits;
  /**
   * Purchase Price (DealLeg.purchasePrice)
   */
  purchasePrice: common.BigDecimal;
  /**
   * Deposit (calculated off DealLeg) (0-100)
   */
  depositPc: common.BigDecimal;
  /**
   * Throughput Fee (DealLeg.throughputFeePc)  (0-100)
   */
  throughputFeePc: common.BigDecimal;
  /**
   * Compulsory Sale Date (DealLeg.compulsorySaleDate)
   */
  compulsorySaleDate: common.LocalDate;
  /**
   * CSD Proportion (DealLeg.compulsorySalePc) (0-100)
   */
  compulsorySalePc: common.BigDecimal;
  /**
   * Final Date (DealLeg.finalDate)
   */
  finalDate: common.LocalDate;
  /**
   * Roll Number (DealLeg.rollNumber)
   */
  rollNumber: number;
  /**
   * Deposit per Unit (DealLeg.depositPrice)
   */
  depositPrice: common.BigDecimal;
  /**
   * Monthly Fee (DealLeg.finalDate)
   */
  monthlyFee: ferovinum_app_db.MonthlyFee;
}

export function makePurchasedStockView(
  input: {
    legIdentifier: common_strings.StringNE,
    dealNumber: common_strings.StringNE,
    dealDate: common.LocalDate,
    paymentDate: common.LocalDate,
    deliveryDate: (common.LocalDate|null),
    locationName: common_strings.StringNE,
    counterparty: common_strings.StringNE,
    code: common_strings.StringNE,
    producerName: common_strings.StringNE,
    name: common_strings.StringNE,
    productDate: ferovinum_app_db.ProductDate,
    vesselSize: (ferovinum_app_db.VesselSize|null),
    unitType: ferovinum_app_db.UnitType,
    countryOfOrigin: common.Country,
    regionOrigin: string,
    alcoholByVolumePc: number,
    productType: ferovinum_app_db.ProductType,
    dutyPaid: boolean,
    numberOfUnits: ferovinum_app_db.NumberOfUnits,
    purchasePrice: common.BigDecimal,
    depositPc: common.BigDecimal,
    throughputFeePc: common.BigDecimal,
    compulsorySaleDate: common.LocalDate,
    compulsorySalePc: common.BigDecimal,
    finalDate: common.LocalDate,
    rollNumber: number,
    depositPrice: common.BigDecimal,
    monthlyFee: ferovinum_app_db.MonthlyFee,
  }
): PurchasedStockView {
  return {
    legIdentifier: input.legIdentifier,
    dealNumber: input.dealNumber,
    dealDate: input.dealDate,
    paymentDate: input.paymentDate,
    deliveryDate: input.deliveryDate,
    locationName: input.locationName,
    counterparty: input.counterparty,
    code: input.code,
    producerName: input.producerName,
    name: input.name,
    productDate: input.productDate,
    vesselSize: input.vesselSize,
    unitType: input.unitType,
    countryOfOrigin: input.countryOfOrigin,
    regionOrigin: input.regionOrigin,
    alcoholByVolumePc: input.alcoholByVolumePc,
    productType: input.productType,
    dutyPaid: input.dutyPaid,
    numberOfUnits: input.numberOfUnits,
    purchasePrice: input.purchasePrice,
    depositPc: input.depositPc,
    throughputFeePc: input.throughputFeePc,
    compulsorySaleDate: input.compulsorySaleDate,
    compulsorySalePc: input.compulsorySalePc,
    finalDate: input.finalDate,
    rollNumber: input.rollNumber,
    depositPrice: input.depositPrice,
    monthlyFee: input.monthlyFee,
  };
}

const PurchasedStockView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[{"value":"Purchased Stock.  The rows of PurchasedStockView are DealLeg with relevant fields joined in from Deal, Product, Organisation.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Leg Identifier (DealLeg->legIdentifier)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"legIdentifier","default":{"kind":"nothing"},"name":"legIdentifier","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Deal Number (Deal->dealNumber)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"dealNumber","default":{"kind":"nothing"},"name":"dealNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Deal Date (Deal->dealDate)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"dealDate","default":{"kind":"nothing"},"name":"dealDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"value":"Payment Date (DealLeg->paymentDate)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"paymentDate","default":{"kind":"nothing"},"name":"paymentDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"value":"Delivery Date (DealLeg->deliveryDate)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"deliveryDate","default":{"kind":"nothing"},"name":"deliveryDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[{"value":"Storage Loc/Acct (DealLeg->StorageLocation->locationName)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"locationName","default":{"kind":"nothing"},"name":"locationName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Counterparty  (Deal->Organisation->businessName)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"counterparty","default":{"kind":"nothing"},"name":"counterparty","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Product Code (DealLeg->Product->code)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Producer (DealLeg->Product->producerName)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"producerName","default":{"kind":"nothing"},"name":"producerName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Product (DealLeg->Product->name)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Vintage / Distillation Date (DealLeg->Product->productDate)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"productDate","default":{"kind":"nothing"},"name":"productDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductDate"}},"parameters":[]}},{"annotations":[{"value":"Vessel information (DealLeg->Product->vesselInfo)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"vesselSize","default":{"kind":"nothing"},"name":"vesselSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"VesselSize"}},"parameters":[]}]}},{"annotations":[{"value":"Unit Type (DealLeg->Product->unitType)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"unitType","default":{"kind":"nothing"},"name":"unitType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"UnitType"}},"parameters":[]}},{"annotations":[{"value":"Country of Origin (DealLeg->Product->countryOfOrigin)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"countryOfOrigin","default":{"kind":"nothing"},"name":"countryOfOrigin","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Country"}},"parameters":[]}},{"annotations":[{"value":"Region / Appellation (DealLeg->Product->regionOrigin)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"regionOrigin","default":{"kind":"nothing"},"name":"regionOrigin","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"ABV (%) (DealLeg->Product->alcoholByVolumePc)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"alcoholByVolumePc","default":{"kind":"nothing"},"name":"alcoholByVolumePc","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[{"value":"Type (DealLeg->Product->productType)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"productType","default":{"kind":"nothing"},"name":"productType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductType"}},"parameters":[]}},{"annotations":[{"value":"Duty Paid / In-Bond (DealLeg.dutyPaid)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"dutyPaid","default":{"kind":"nothing"},"name":"dutyPaid","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"value":"Number of Units (DealLeg.numberOfUnits)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"numberOfUnits","default":{"kind":"nothing"},"name":"numberOfUnits","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[{"value":"Purchase Price (DealLeg.purchasePrice)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"purchasePrice","default":{"kind":"nothing"},"name":"purchasePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Deposit (calculated off DealLeg) (0-100)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"depositPc","default":{"kind":"nothing"},"name":"depositPc","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Throughput Fee (DealLeg.throughputFeePc)  (0-100)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"throughputFeePc","default":{"kind":"nothing"},"name":"throughputFeePc","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Compulsory Sale Date (DealLeg.compulsorySaleDate)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"compulsorySaleDate","default":{"kind":"nothing"},"name":"compulsorySaleDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"value":"CSD Proportion (DealLeg.compulsorySalePc) (0-100)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"compulsorySalePc","default":{"kind":"nothing"},"name":"compulsorySalePc","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Final Date (DealLeg.finalDate)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"finalDate","default":{"kind":"nothing"},"name":"finalDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"value":"Roll Number (DealLeg.rollNumber)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"rollNumber","default":{"kind":"nothing"},"name":"rollNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Word32"},"parameters":[]}},{"annotations":[{"value":"Deposit per Unit (DealLeg.depositPrice)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"depositPrice","default":{"kind":"nothing"},"name":"depositPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[{"value":"Monthly Fee (DealLeg.finalDate)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"monthlyFee","default":{"kind":"nothing"},"name":"monthlyFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"MonthlyFee"}},"parameters":[]}}]}},"name":"PurchasedStockView","version":{"kind":"nothing"}}};

export const snPurchasedStockView: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"PurchasedStockView"};

export function texprPurchasedStockView(): ADL.ATypeExpr<PurchasedStockView> {
  return {value : {typeRef : {kind: "reference", value : snPurchasedStockView}, parameters : []}};
}

export type SoldStockCSV = CSVData<SoldStockView>;

const SoldStockCSV_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"CSVData"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"SoldStockView"}},"parameters":[]}]}}},"name":"SoldStockCSV","version":{"kind":"nothing"}}};

export const snSoldStockCSV: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"SoldStockCSV"};

export function texprSoldStockCSV(): ADL.ATypeExpr<SoldStockCSV> {
  return {value : {typeRef : {kind: "reference", value : snSoldStockCSV}, parameters : []}};
}

export interface SoldStockView {
  /**
   * Sale Date (SaleOrder.saleDate)
   */
  saleDate: common.LocalDate;
  /**
   * Leg Identifier (DealLeg.legIdentifier)
   */
  legIdentifier: common_strings.StringNE;
  /**
   * Units Sold (DealLegSale.unitsSold)
   */
  unitsSold: ferovinum_app_db.NumberOfUnits;
  invoiceNumber: common_strings.StringNE;
  dutyPaid: boolean;
  postCode: (string|null);
}

export function makeSoldStockView(
  input: {
    saleDate: common.LocalDate,
    legIdentifier: common_strings.StringNE,
    unitsSold: ferovinum_app_db.NumberOfUnits,
    invoiceNumber: common_strings.StringNE,
    dutyPaid: boolean,
    postCode: (string|null),
  }
): SoldStockView {
  return {
    saleDate: input.saleDate,
    legIdentifier: input.legIdentifier,
    unitsSold: input.unitsSold,
    invoiceNumber: input.invoiceNumber,
    dutyPaid: input.dutyPaid,
    postCode: input.postCode,
  };
}

const SoldStockView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Sale Date (SaleOrder.saleDate)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"saleDate","default":{"kind":"nothing"},"name":"saleDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"value":"Leg Identifier (DealLeg.legIdentifier)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"legIdentifier","default":{"kind":"nothing"},"name":"legIdentifier","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Units Sold (DealLegSale.unitsSold)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"unitsSold","default":{"kind":"nothing"},"name":"unitsSold","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"invoiceNumber","default":{"kind":"nothing"},"name":"invoiceNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"dutyPaid","default":{"kind":"nothing"},"name":"dutyPaid","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"postCode","default":{"kind":"nothing"},"name":"postCode","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"SoldStockView","version":{"kind":"nothing"}}};

export const snSoldStockView: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"SoldStockView"};

export function texprSoldStockView(): ADL.ATypeExpr<SoldStockView> {
  return {value : {typeRef : {kind: "reference", value : snSoldStockView}, parameters : []}};
}

export type CapitalisedExpensesCSV = CSVData<CapitalisedExpensesView>;

const CapitalisedExpensesCSV_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"CSVData"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"CapitalisedExpensesView"}},"parameters":[]}]}}},"name":"CapitalisedExpensesCSV","version":{"kind":"nothing"}}};

export const snCapitalisedExpensesCSV: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"CapitalisedExpensesCSV"};

export function texprCapitalisedExpensesCSV(): ADL.ATypeExpr<CapitalisedExpensesCSV> {
  return {value : {typeRef : {kind: "reference", value : snCapitalisedExpensesCSV}, parameters : []}};
}

export interface CapitalisedExpensesView {
  businessName: (common_strings.StringNE|null);
  dealNumber: (common_strings.StringNE|null);
  legIdentifier: (common_strings.StringNE|null);
  expenseDate: common.LocalDate;
  expenseType: string;
  vendor: string;
  amountPaid: common.BigDecimal;
  valueAccretive: boolean;
}

export function makeCapitalisedExpensesView(
  input: {
    businessName: (common_strings.StringNE|null),
    dealNumber: (common_strings.StringNE|null),
    legIdentifier: (common_strings.StringNE|null),
    expenseDate: common.LocalDate,
    expenseType: string,
    vendor: string,
    amountPaid: common.BigDecimal,
    valueAccretive: boolean,
  }
): CapitalisedExpensesView {
  return {
    businessName: input.businessName,
    dealNumber: input.dealNumber,
    legIdentifier: input.legIdentifier,
    expenseDate: input.expenseDate,
    expenseType: input.expenseType,
    vendor: input.vendor,
    amountPaid: input.amountPaid,
    valueAccretive: input.valueAccretive,
  };
}

const CapitalisedExpensesView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"businessName","default":{"kind":"nothing"},"name":"businessName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"dealNumber","default":{"kind":"nothing"},"name":"dealNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"legIdentifier","default":{"kind":"nothing"},"name":"legIdentifier","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"expenseDate","default":{"kind":"nothing"},"name":"expenseDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseType","default":{"kind":"nothing"},"name":"expenseType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"vendor","default":{"kind":"nothing"},"name":"vendor","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"amountPaid","default":{"kind":"nothing"},"name":"amountPaid","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"valueAccretive","default":{"kind":"nothing"},"name":"valueAccretive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"CapitalisedExpensesView","version":{"kind":"nothing"}}};

export const snCapitalisedExpensesView: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"CapitalisedExpensesView"};

export function texprCapitalisedExpensesView(): ADL.ATypeExpr<CapitalisedExpensesView> {
  return {value : {typeRef : {kind: "reference", value : snCapitalisedExpensesView}, parameters : []}};
}

export type OrganisationAvailableStockViewCSV = CSVData<OrganisationAvailableStockView>;

const OrganisationAvailableStockViewCSV_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"CSVData"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"OrganisationAvailableStockView"}},"parameters":[]}]}}},"name":"OrganisationAvailableStockViewCSV","version":{"kind":"nothing"}}};

export const snOrganisationAvailableStockViewCSV: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"OrganisationAvailableStockViewCSV"};

export function texprOrganisationAvailableStockViewCSV(): ADL.ATypeExpr<OrganisationAvailableStockViewCSV> {
  return {value : {typeRef : {kind: "reference", value : snOrganisationAvailableStockViewCSV}, parameters : []}};
}

export interface OrganisationAvailableStockView {
  code: common_strings.StringNE;
  producerName: common_strings.StringNE;
  name: common_strings.StringNE;
  /**
   * Vintage / Distillation Date (or NonVintage flag)
   */
  productDate: ferovinum_app_db.ProductDate;
  vesselSize: (ferovinum_app_db.VesselSize|null);
  unitType: ferovinum_app_db.UnitType;
  unitsRemaining: ferovinum_app_db.NumberOfUnits;
  storageLocationName: common_strings.StringNE;
}

export function makeOrganisationAvailableStockView(
  input: {
    code: common_strings.StringNE,
    producerName: common_strings.StringNE,
    name: common_strings.StringNE,
    productDate: ferovinum_app_db.ProductDate,
    vesselSize: (ferovinum_app_db.VesselSize|null),
    unitType: ferovinum_app_db.UnitType,
    unitsRemaining: ferovinum_app_db.NumberOfUnits,
    storageLocationName: common_strings.StringNE,
  }
): OrganisationAvailableStockView {
  return {
    code: input.code,
    producerName: input.producerName,
    name: input.name,
    productDate: input.productDate,
    vesselSize: input.vesselSize,
    unitType: input.unitType,
    unitsRemaining: input.unitsRemaining,
    storageLocationName: input.storageLocationName,
  };
}

const OrganisationAvailableStockView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"producerName","default":{"kind":"nothing"},"name":"producerName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Vintage / Distillation Date (or NonVintage flag)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"productDate","default":{"kind":"nothing"},"name":"productDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductDate"}},"parameters":[]}},{"annotations":[],"serializedName":"vesselSize","default":{"kind":"nothing"},"name":"vesselSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"VesselSize"}},"parameters":[]}]}},{"annotations":[],"serializedName":"unitType","default":{"kind":"nothing"},"name":"unitType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"UnitType"}},"parameters":[]}},{"annotations":[],"serializedName":"unitsRemaining","default":{"kind":"nothing"},"name":"unitsRemaining","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"storageLocationName","default":{"kind":"nothing"},"name":"storageLocationName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"OrganisationAvailableStockView","version":{"kind":"nothing"}}};

export const snOrganisationAvailableStockView: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"OrganisationAvailableStockView"};

export function texprOrganisationAvailableStockView(): ADL.ATypeExpr<OrganisationAvailableStockView> {
  return {value : {typeRef : {kind: "reference", value : snOrganisationAvailableStockView}, parameters : []}};
}

export interface SinglesProductBalancesView {
  code: common_strings.StringNE;
  name: common_strings.StringNE;
  producerName: common_strings.StringNE;
  /**
   * Vintage / Distillation Date (or NonVintage flag)
   */
  productDate: ferovinum_app_db.ProductDate;
  vesselSize: (ferovinum_app_db.VesselSize|null);
  unitType: ferovinum_app_db.UnitType;
  unitsTotal: ferovinum_app_db.NumberOfUnits;
  unitsReserved: ferovinum_app_db.NumberOfUnits;
  unitsUnreconciled: ferovinum_app_db.NumberOfUnits;
}

export function makeSinglesProductBalancesView(
  input: {
    code: common_strings.StringNE,
    name: common_strings.StringNE,
    producerName: common_strings.StringNE,
    productDate: ferovinum_app_db.ProductDate,
    vesselSize: (ferovinum_app_db.VesselSize|null),
    unitType: ferovinum_app_db.UnitType,
    unitsTotal: ferovinum_app_db.NumberOfUnits,
    unitsReserved: ferovinum_app_db.NumberOfUnits,
    unitsUnreconciled: ferovinum_app_db.NumberOfUnits,
  }
): SinglesProductBalancesView {
  return {
    code: input.code,
    name: input.name,
    producerName: input.producerName,
    productDate: input.productDate,
    vesselSize: input.vesselSize,
    unitType: input.unitType,
    unitsTotal: input.unitsTotal,
    unitsReserved: input.unitsReserved,
    unitsUnreconciled: input.unitsUnreconciled,
  };
}

const SinglesProductBalancesView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"producerName","default":{"kind":"nothing"},"name":"producerName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Vintage / Distillation Date (or NonVintage flag)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"productDate","default":{"kind":"nothing"},"name":"productDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductDate"}},"parameters":[]}},{"annotations":[],"serializedName":"vesselSize","default":{"kind":"nothing"},"name":"vesselSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"VesselSize"}},"parameters":[]}]}},{"annotations":[],"serializedName":"unitType","default":{"kind":"nothing"},"name":"unitType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"UnitType"}},"parameters":[]}},{"annotations":[],"serializedName":"unitsTotal","default":{"kind":"nothing"},"name":"unitsTotal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"unitsReserved","default":{"kind":"nothing"},"name":"unitsReserved","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"unitsUnreconciled","default":{"kind":"nothing"},"name":"unitsUnreconciled","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"SinglesProductBalancesView","version":{"kind":"nothing"}}};

export const snSinglesProductBalancesView: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"SinglesProductBalancesView"};

export function texprSinglesProductBalancesView(): ADL.ATypeExpr<SinglesProductBalancesView> {
  return {value : {typeRef : {kind: "reference", value : snSinglesProductBalancesView}, parameters : []}};
}

export interface NonSinglesProductBalancesView {
  code: common_strings.StringNE;
  name: common_strings.StringNE;
  producerName: common_strings.StringNE;
  /**
   * Vintage / Distillation Date (or NonVintage flag)
   */
  productDate: ferovinum_app_db.ProductDate;
  vesselSize: ferovinum_app_db.NumberOfUnits;
}

export function makeNonSinglesProductBalancesView(
  input: {
    code: common_strings.StringNE,
    name: common_strings.StringNE,
    producerName: common_strings.StringNE,
    productDate: ferovinum_app_db.ProductDate,
    vesselSize: ferovinum_app_db.NumberOfUnits,
  }
): NonSinglesProductBalancesView {
  return {
    code: input.code,
    name: input.name,
    producerName: input.producerName,
    productDate: input.productDate,
    vesselSize: input.vesselSize,
  };
}

const NonSinglesProductBalancesView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"producerName","default":{"kind":"nothing"},"name":"producerName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"value":"Vintage / Distillation Date (or NonVintage flag)\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"productDate","default":{"kind":"nothing"},"name":"productDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductDate"}},"parameters":[]}},{"annotations":[],"serializedName":"vesselSize","default":{"kind":"nothing"},"name":"vesselSize","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"NonSinglesProductBalancesView","version":{"kind":"nothing"}}};

export const snNonSinglesProductBalancesView: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"NonSinglesProductBalancesView"};

export function texprNonSinglesProductBalancesView(): ADL.ATypeExpr<NonSinglesProductBalancesView> {
  return {value : {typeRef : {kind: "reference", value : snNonSinglesProductBalancesView}, parameters : []}};
}

export interface FSP {
  unroundedFsp: common.BigDecimal;
  roundedFsp: common.BigDecimal;
}

export function makeFSP(
  input: {
    unroundedFsp: common.BigDecimal,
    roundedFsp: common.BigDecimal,
  }
): FSP {
  return {
    unroundedFsp: input.unroundedFsp,
    roundedFsp: input.roundedFsp,
  };
}

const FSP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"unroundedFsp","default":{"kind":"nothing"},"name":"unroundedFsp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"roundedFsp","default":{"kind":"nothing"},"name":"roundedFsp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"FSP","version":{"kind":"nothing"}}};

export const snFSP: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"FSP"};

export function texprFSP(): ADL.ATypeExpr<FSP> {
  return {value : {typeRef : {kind: "reference", value : snFSP}, parameters : []}};
}

export interface ForwardSalePriceCalculationView {
  fsp: FSP;
  basePrice: common.BigDecimal;
  deposit: common.BigDecimal;
  monthlyFee: common.BigDecimal;
  throughputFee: common.BigDecimal;
  capitalisedExpenses: CapitalisedExpenseFspContributionView[];
}

export function makeForwardSalePriceCalculationView(
  input: {
    fsp: FSP,
    basePrice: common.BigDecimal,
    deposit: common.BigDecimal,
    monthlyFee: common.BigDecimal,
    throughputFee: common.BigDecimal,
    capitalisedExpenses: CapitalisedExpenseFspContributionView[],
  }
): ForwardSalePriceCalculationView {
  return {
    fsp: input.fsp,
    basePrice: input.basePrice,
    deposit: input.deposit,
    monthlyFee: input.monthlyFee,
    throughputFee: input.throughputFee,
    capitalisedExpenses: input.capitalisedExpenses,
  };
}

const ForwardSalePriceCalculationView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fsp","default":{"kind":"nothing"},"name":"fsp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"FSP"}},"parameters":[]}},{"annotations":[],"serializedName":"basePrice","default":{"kind":"nothing"},"name":"basePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"deposit","default":{"kind":"nothing"},"name":"deposit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"monthlyFee","default":{"kind":"nothing"},"name":"monthlyFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"throughputFee","default":{"kind":"nothing"},"name":"throughputFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"capitalisedExpenses","default":{"kind":"nothing"},"name":"capitalisedExpenses","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"CapitalisedExpenseFspContributionView"}},"parameters":[]}]}}]}},"name":"ForwardSalePriceCalculationView","version":{"kind":"nothing"}}};

export const snForwardSalePriceCalculationView: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"ForwardSalePriceCalculationView"};

export function texprForwardSalePriceCalculationView(): ADL.ATypeExpr<ForwardSalePriceCalculationView> {
  return {value : {typeRef : {kind: "reference", value : snForwardSalePriceCalculationView}, parameters : []}};
}

export interface CapitalisedExpenseFspContributionView {
  capitalisedExpenseId: ferovinum_app_db.CapitalisedExpenseId;
  expenseDate: common.LocalDate;
  totalPricePerUnit: common.BigDecimal;
  basePricePerUnit: common.BigDecimal;
  monthlyFee: common.BigDecimal;
  throughputFee: common.BigDecimal;
}

export function makeCapitalisedExpenseFspContributionView(
  input: {
    capitalisedExpenseId: ferovinum_app_db.CapitalisedExpenseId,
    expenseDate: common.LocalDate,
    totalPricePerUnit: common.BigDecimal,
    basePricePerUnit: common.BigDecimal,
    monthlyFee: common.BigDecimal,
    throughputFee: common.BigDecimal,
  }
): CapitalisedExpenseFspContributionView {
  return {
    capitalisedExpenseId: input.capitalisedExpenseId,
    expenseDate: input.expenseDate,
    totalPricePerUnit: input.totalPricePerUnit,
    basePricePerUnit: input.basePricePerUnit,
    monthlyFee: input.monthlyFee,
    throughputFee: input.throughputFee,
  };
}

const CapitalisedExpenseFspContributionView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"capitalisedExpenseId","default":{"kind":"nothing"},"name":"capitalisedExpenseId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseId"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseDate","default":{"kind":"nothing"},"name":"expenseDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"totalPricePerUnit","default":{"kind":"nothing"},"name":"totalPricePerUnit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"basePricePerUnit","default":{"kind":"nothing"},"name":"basePricePerUnit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"monthlyFee","default":{"kind":"nothing"},"name":"monthlyFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"throughputFee","default":{"kind":"nothing"},"name":"throughputFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"CapitalisedExpenseFspContributionView","version":{"kind":"nothing"}}};

export const snCapitalisedExpenseFspContributionView: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"CapitalisedExpenseFspContributionView"};

export function texprCapitalisedExpenseFspContributionView(): ADL.ATypeExpr<CapitalisedExpenseFspContributionView> {
  return {value : {typeRef : {kind: "reference", value : snCapitalisedExpenseFspContributionView}, parameters : []}};
}

export interface ProductMovementReport {
  /**
   * The storage location that this movement report is filtered by
   */
  totalsPerStorageLocationName: sys_types.Map<MinimalStorageLocationView, ProductMovementTotals>;
  product: ferovinum_app_db.Product;
  availableStockLineItems: AvailableStockLineItem[];
  pendingStockLineItems: PendingStockLineItem[];
}

export function makeProductMovementReport(
  input: {
    totalsPerStorageLocationName: sys_types.Map<MinimalStorageLocationView, ProductMovementTotals>,
    product: ferovinum_app_db.Product,
    availableStockLineItems: AvailableStockLineItem[],
    pendingStockLineItems: PendingStockLineItem[],
  }
): ProductMovementReport {
  return {
    totalsPerStorageLocationName: input.totalsPerStorageLocationName,
    product: input.product,
    availableStockLineItems: input.availableStockLineItems,
    pendingStockLineItems: input.pendingStockLineItems,
  };
}

const ProductMovementReport_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"The storage location that this movement report is filtered by\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"totalsPerStorageLocationName","default":{"kind":"nothing"},"name":"totalsPerStorageLocationName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"MinimalStorageLocationView"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"ProductMovementTotals"}},"parameters":[]}]}},{"annotations":[],"serializedName":"product","default":{"kind":"nothing"},"name":"product","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Product"}},"parameters":[]}},{"annotations":[],"serializedName":"availableStockLineItems","default":{"kind":"nothing"},"name":"availableStockLineItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"AvailableStockLineItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"pendingStockLineItems","default":{"kind":"nothing"},"name":"pendingStockLineItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"PendingStockLineItem"}},"parameters":[]}]}}]}},"name":"ProductMovementReport","version":{"kind":"nothing"}}};

export const snProductMovementReport: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"ProductMovementReport"};

export function texprProductMovementReport(): ADL.ATypeExpr<ProductMovementReport> {
  return {value : {typeRef : {kind: "reference", value : snProductMovementReport}, parameters : []}};
}

export interface MinimalStorageLocationView {
  storageLocationId: ferovinum_app_db.StorageLocationId;
  storageLocationName: common_strings.StringNE;
}

export function makeMinimalStorageLocationView(
  input: {
    storageLocationId: ferovinum_app_db.StorageLocationId,
    storageLocationName: common_strings.StringNE,
  }
): MinimalStorageLocationView {
  return {
    storageLocationId: input.storageLocationId,
    storageLocationName: input.storageLocationName,
  };
}

const MinimalStorageLocationView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"storageLocationId","default":{"kind":"nothing"},"name":"storageLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"storageLocationName","default":{"kind":"nothing"},"name":"storageLocationName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"MinimalStorageLocationView","version":{"kind":"nothing"}}};

export const snMinimalStorageLocationView: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"MinimalStorageLocationView"};

export function texprMinimalStorageLocationView(): ADL.ATypeExpr<MinimalStorageLocationView> {
  return {value : {typeRef : {kind: "reference", value : snMinimalStorageLocationView}, parameters : []}};
}

export interface ProductMovementTotals {
  totalAvailable: ferovinum_app_db.NumberOfUnits;
  totalPending: ferovinum_app_db.NumberOfUnits;
}

export function makeProductMovementTotals(
  input: {
    totalAvailable: ferovinum_app_db.NumberOfUnits,
    totalPending: ferovinum_app_db.NumberOfUnits,
  }
): ProductMovementTotals {
  return {
    totalAvailable: input.totalAvailable,
    totalPending: input.totalPending,
  };
}

const ProductMovementTotals_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"totalAvailable","default":{"kind":"nothing"},"name":"totalAvailable","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"totalPending","default":{"kind":"nothing"},"name":"totalPending","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}}]}},"name":"ProductMovementTotals","version":{"kind":"nothing"}}};

export const snProductMovementTotals: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"ProductMovementTotals"};

export function texprProductMovementTotals(): ADL.ATypeExpr<ProductMovementTotals> {
  return {value : {typeRef : {kind: "reference", value : snProductMovementTotals}, parameters : []}};
}

export interface AvailableStockLineItem {
  timestamp: common.Instant;
  quantity: ferovinum_app_db.NumberOfUnits;
  lineItemType: AvailableStockLineItemType;
  storageLocationId: ferovinum_app_db.StorageLocationId;
}

export function makeAvailableStockLineItem(
  input: {
    timestamp: common.Instant,
    quantity: ferovinum_app_db.NumberOfUnits,
    lineItemType: AvailableStockLineItemType,
    storageLocationId: ferovinum_app_db.StorageLocationId,
  }
): AvailableStockLineItem {
  return {
    timestamp: input.timestamp,
    quantity: input.quantity,
    lineItemType: input.lineItemType,
    storageLocationId: input.storageLocationId,
  };
}

const AvailableStockLineItem_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"timestamp","default":{"kind":"nothing"},"name":"timestamp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"lineItemType","default":{"kind":"nothing"},"name":"lineItemType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"AvailableStockLineItemType"}},"parameters":[]}},{"annotations":[],"serializedName":"storageLocationId","default":{"kind":"nothing"},"name":"storageLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}}]}},"name":"AvailableStockLineItem","version":{"kind":"nothing"}}};

export const snAvailableStockLineItem: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"AvailableStockLineItem"};

export function texprAvailableStockLineItem(): ADL.ATypeExpr<AvailableStockLineItem> {
  return {value : {typeRef : {kind: "reference", value : snAvailableStockLineItem}, parameters : []}};
}

export interface AvailableStockLineItemType_AddedFromDealLeg {
  kind: 'addedFromDealLeg';
  value: DealLegLineItemData;
}
export interface AvailableStockLineItemType_Repurchased {
  kind: 'repurchased';
  value: SaleOrderLineItemData;
}
export interface AvailableStockLineItemType_AllocatedToProductionOrder {
  kind: 'allocatedToProductionOrder';
  value: ProductionOrderLineItemData;
}
export interface AvailableStockLineItemType_ResultOfProductionOrder {
  kind: 'resultOfProductionOrder';
  value: ProductionOrderLineItemData;
}
export interface AvailableStockLineItemType_ProductionOrderTaskRunLoss {
  kind: 'productionOrderTaskRunLoss';
  value: ProductionOrderLineItemData;
}
export interface AvailableStockLineItemType_AllocatedToStockMovement {
  kind: 'allocatedToStockMovement';
  value: StockMovementLineItemData;
}
export interface AvailableStockLineItemType_ResultOfStockMovement {
  kind: 'resultOfStockMovement';
  value: StockMovementLineItemData;
}
export interface AvailableStockLineItemType_ResultOfNewStockDelivery {
  kind: 'resultOfNewStockDelivery';
  value: NewDealRequestLineItemData;
}
export interface AvailableStockLineItemType_ResultOfExistingStockNewDealRequest {
  kind: 'resultOfExistingStockNewDealRequest';
  value: NewDealRequestLineItemData;
}
export interface AvailableStockLineItemType_AllocatedToPurchaseRequest {
  kind: 'allocatedToPurchaseRequest';
  value: PurchaseRequestLineItemData;
}
export interface AvailableStockLineItemType_AllocatedToNegativeStockAdjustment {
  kind: 'allocatedToNegativeStockAdjustment';
  value: NegativeStockAdjustmentData;
}

export type AvailableStockLineItemType = AvailableStockLineItemType_AddedFromDealLeg | AvailableStockLineItemType_Repurchased | AvailableStockLineItemType_AllocatedToProductionOrder | AvailableStockLineItemType_ResultOfProductionOrder | AvailableStockLineItemType_ProductionOrderTaskRunLoss | AvailableStockLineItemType_AllocatedToStockMovement | AvailableStockLineItemType_ResultOfStockMovement | AvailableStockLineItemType_ResultOfNewStockDelivery | AvailableStockLineItemType_ResultOfExistingStockNewDealRequest | AvailableStockLineItemType_AllocatedToPurchaseRequest | AvailableStockLineItemType_AllocatedToNegativeStockAdjustment;

export interface AvailableStockLineItemTypeOpts {
  addedFromDealLeg: DealLegLineItemData;
  repurchased: SaleOrderLineItemData;
  allocatedToProductionOrder: ProductionOrderLineItemData;
  resultOfProductionOrder: ProductionOrderLineItemData;
  productionOrderTaskRunLoss: ProductionOrderLineItemData;
  allocatedToStockMovement: StockMovementLineItemData;
  resultOfStockMovement: StockMovementLineItemData;
  resultOfNewStockDelivery: NewDealRequestLineItemData;
  resultOfExistingStockNewDealRequest: NewDealRequestLineItemData;
  allocatedToPurchaseRequest: PurchaseRequestLineItemData;
  allocatedToNegativeStockAdjustment: NegativeStockAdjustmentData;
}

export function makeAvailableStockLineItemType<K extends keyof AvailableStockLineItemTypeOpts>(kind: K, value: AvailableStockLineItemTypeOpts[K]) { return {kind, value}; }

const AvailableStockLineItemType_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"addedFromDealLeg","default":{"kind":"nothing"},"name":"addedFromDealLeg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"DealLegLineItemData"}},"parameters":[]}},{"annotations":[],"serializedName":"repurchased","default":{"kind":"nothing"},"name":"repurchased","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"SaleOrderLineItemData"}},"parameters":[]}},{"annotations":[],"serializedName":"allocatedToProductionOrder","default":{"kind":"nothing"},"name":"allocatedToProductionOrder","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"ProductionOrderLineItemData"}},"parameters":[]}},{"annotations":[],"serializedName":"resultOfProductionOrder","default":{"kind":"nothing"},"name":"resultOfProductionOrder","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"ProductionOrderLineItemData"}},"parameters":[]}},{"annotations":[],"serializedName":"productionOrderTaskRunLoss","default":{"kind":"nothing"},"name":"productionOrderTaskRunLoss","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"ProductionOrderLineItemData"}},"parameters":[]}},{"annotations":[],"serializedName":"allocatedToStockMovement","default":{"kind":"nothing"},"name":"allocatedToStockMovement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"StockMovementLineItemData"}},"parameters":[]}},{"annotations":[],"serializedName":"resultOfStockMovement","default":{"kind":"nothing"},"name":"resultOfStockMovement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"StockMovementLineItemData"}},"parameters":[]}},{"annotations":[],"serializedName":"resultOfNewStockDelivery","default":{"kind":"nothing"},"name":"resultOfNewStockDelivery","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"NewDealRequestLineItemData"}},"parameters":[]}},{"annotations":[],"serializedName":"resultOfExistingStockNewDealRequest","default":{"kind":"nothing"},"name":"resultOfExistingStockNewDealRequest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"NewDealRequestLineItemData"}},"parameters":[]}},{"annotations":[],"serializedName":"allocatedToPurchaseRequest","default":{"kind":"nothing"},"name":"allocatedToPurchaseRequest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"PurchaseRequestLineItemData"}},"parameters":[]}},{"annotations":[],"serializedName":"allocatedToNegativeStockAdjustment","default":{"kind":"nothing"},"name":"allocatedToNegativeStockAdjustment","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"NegativeStockAdjustmentData"}},"parameters":[]}}]}},"name":"AvailableStockLineItemType","version":{"kind":"nothing"}}};

export const snAvailableStockLineItemType: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"AvailableStockLineItemType"};

export function texprAvailableStockLineItemType(): ADL.ATypeExpr<AvailableStockLineItemType> {
  return {value : {typeRef : {kind: "reference", value : snAvailableStockLineItemType}, parameters : []}};
}

export interface NegativeStockAdjustmentData {
  reasonForStockAdjustment: (string|null);
}

export function makeNegativeStockAdjustmentData(
  input: {
    reasonForStockAdjustment: (string|null),
  }
): NegativeStockAdjustmentData {
  return {
    reasonForStockAdjustment: input.reasonForStockAdjustment,
  };
}

const NegativeStockAdjustmentData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"reasonForStockAdjustment","default":{"kind":"nothing"},"name":"reasonForStockAdjustment","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"NegativeStockAdjustmentData","version":{"kind":"nothing"}}};

export const snNegativeStockAdjustmentData: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"NegativeStockAdjustmentData"};

export function texprNegativeStockAdjustmentData(): ADL.ATypeExpr<NegativeStockAdjustmentData> {
  return {value : {typeRef : {kind: "reference", value : snNegativeStockAdjustmentData}, parameters : []}};
}

export interface DealLegLineItemData {
  dealLegId: ferovinum_app_db.DealLegId;
  legIdentifier: string;
}

export function makeDealLegLineItemData(
  input: {
    dealLegId: ferovinum_app_db.DealLegId,
    legIdentifier: string,
  }
): DealLegLineItemData {
  return {
    dealLegId: input.dealLegId,
    legIdentifier: input.legIdentifier,
  };
}

const DealLegLineItemData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"dealLegId","default":{"kind":"nothing"},"name":"dealLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"legIdentifier","default":{"kind":"nothing"},"name":"legIdentifier","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"DealLegLineItemData","version":{"kind":"nothing"}}};

export const snDealLegLineItemData: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"DealLegLineItemData"};

export function texprDealLegLineItemData(): ADL.ATypeExpr<DealLegLineItemData> {
  return {value : {typeRef : {kind: "reference", value : snDealLegLineItemData}, parameters : []}};
}

export interface SaleOrderLineItemData {
  saleOrderId: ferovinum_app_db.SaleOrderId;
  invoiceNumber: string;
}

export function makeSaleOrderLineItemData(
  input: {
    saleOrderId: ferovinum_app_db.SaleOrderId,
    invoiceNumber: string,
  }
): SaleOrderLineItemData {
  return {
    saleOrderId: input.saleOrderId,
    invoiceNumber: input.invoiceNumber,
  };
}

const SaleOrderLineItemData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"saleOrderId","default":{"kind":"nothing"},"name":"saleOrderId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SaleOrderId"}},"parameters":[]}},{"annotations":[],"serializedName":"invoiceNumber","default":{"kind":"nothing"},"name":"invoiceNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"SaleOrderLineItemData","version":{"kind":"nothing"}}};

export const snSaleOrderLineItemData: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"SaleOrderLineItemData"};

export function texprSaleOrderLineItemData(): ADL.ATypeExpr<SaleOrderLineItemData> {
  return {value : {typeRef : {kind: "reference", value : snSaleOrderLineItemData}, parameters : []}};
}

export interface ProductionOrderLineItemData {
  productionOrderId: ferovinum_app_db.ProductionOrderId;
  orderNumber: string;
}

export function makeProductionOrderLineItemData(
  input: {
    productionOrderId: ferovinum_app_db.ProductionOrderId,
    orderNumber: string,
  }
): ProductionOrderLineItemData {
  return {
    productionOrderId: input.productionOrderId,
    orderNumber: input.orderNumber,
  };
}

const ProductionOrderLineItemData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"productionOrderId","default":{"kind":"nothing"},"name":"productionOrderId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductionOrderId"}},"parameters":[]}},{"annotations":[],"serializedName":"orderNumber","default":{"kind":"nothing"},"name":"orderNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"ProductionOrderLineItemData","version":{"kind":"nothing"}}};

export const snProductionOrderLineItemData: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"ProductionOrderLineItemData"};

export function texprProductionOrderLineItemData(): ADL.ATypeExpr<ProductionOrderLineItemData> {
  return {value : {typeRef : {kind: "reference", value : snProductionOrderLineItemData}, parameters : []}};
}

export interface NewDealRequestLineItemData {
  newDealRequestId: ferovinum_app_db.NewDealRequestId;
  dealNumber: string;
}

export function makeNewDealRequestLineItemData(
  input: {
    newDealRequestId: ferovinum_app_db.NewDealRequestId,
    dealNumber: string,
  }
): NewDealRequestLineItemData {
  return {
    newDealRequestId: input.newDealRequestId,
    dealNumber: input.dealNumber,
  };
}

const NewDealRequestLineItemData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"newDealRequestId","default":{"kind":"nothing"},"name":"newDealRequestId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NewDealRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"dealNumber","default":{"kind":"nothing"},"name":"dealNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"NewDealRequestLineItemData","version":{"kind":"nothing"}}};

export const snNewDealRequestLineItemData: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"NewDealRequestLineItemData"};

export function texprNewDealRequestLineItemData(): ADL.ATypeExpr<NewDealRequestLineItemData> {
  return {value : {typeRef : {kind: "reference", value : snNewDealRequestLineItemData}, parameters : []}};
}

export interface StockMovementLineItemData {
  /**
   * Name of the storage location where the stock was moved to/from
   */
  otherStorageLocationName: string;
}

export function makeStockMovementLineItemData(
  input: {
    otherStorageLocationName: string,
  }
): StockMovementLineItemData {
  return {
    otherStorageLocationName: input.otherStorageLocationName,
  };
}

const StockMovementLineItemData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Name of the storage location where the stock was moved to/from\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"otherStorageLocationName","default":{"kind":"nothing"},"name":"otherStorageLocationName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"StockMovementLineItemData","version":{"kind":"nothing"}}};

export const snStockMovementLineItemData: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"StockMovementLineItemData"};

export function texprStockMovementLineItemData(): ADL.ATypeExpr<StockMovementLineItemData> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementLineItemData}, parameters : []}};
}

export interface PurchaseRequestLineItemData {
  purchaseRequestId: ferovinum_app_db.PurchaseRequestId;
  purchaseRequestNumber: string;
}

export function makePurchaseRequestLineItemData(
  input: {
    purchaseRequestId: ferovinum_app_db.PurchaseRequestId,
    purchaseRequestNumber: string,
  }
): PurchaseRequestLineItemData {
  return {
    purchaseRequestId: input.purchaseRequestId,
    purchaseRequestNumber: input.purchaseRequestNumber,
  };
}

const PurchaseRequestLineItemData_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"purchaseRequestId","default":{"kind":"nothing"},"name":"purchaseRequestId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PurchaseRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"purchaseRequestNumber","default":{"kind":"nothing"},"name":"purchaseRequestNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"PurchaseRequestLineItemData","version":{"kind":"nothing"}}};

export const snPurchaseRequestLineItemData: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"PurchaseRequestLineItemData"};

export function texprPurchaseRequestLineItemData(): ADL.ATypeExpr<PurchaseRequestLineItemData> {
  return {value : {typeRef : {kind: "reference", value : snPurchaseRequestLineItemData}, parameters : []}};
}

export interface PendingStockLineItem {
  timestamp: common.Instant;
  availableTimestamp: (common.Instant|null);
  quantity: ferovinum_app_db.NumberOfUnits;
  lineItemType: PendingStockLineItemType;
  storageLocationId: ferovinum_app_db.StorageLocationId;
}

export function makePendingStockLineItem(
  input: {
    timestamp: common.Instant,
    availableTimestamp: (common.Instant|null),
    quantity: ferovinum_app_db.NumberOfUnits,
    lineItemType: PendingStockLineItemType,
    storageLocationId: ferovinum_app_db.StorageLocationId,
  }
): PendingStockLineItem {
  return {
    timestamp: input.timestamp,
    availableTimestamp: input.availableTimestamp,
    quantity: input.quantity,
    lineItemType: input.lineItemType,
    storageLocationId: input.storageLocationId,
  };
}

const PendingStockLineItem_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"timestamp","default":{"kind":"nothing"},"name":"timestamp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"availableTimestamp","default":{"kind":"nothing"},"name":"availableTimestamp","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"lineItemType","default":{"kind":"nothing"},"name":"lineItemType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"PendingStockLineItemType"}},"parameters":[]}},{"annotations":[],"serializedName":"storageLocationId","default":{"kind":"nothing"},"name":"storageLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}}]}},"name":"PendingStockLineItem","version":{"kind":"nothing"}}};

export const snPendingStockLineItem: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"PendingStockLineItem"};

export function texprPendingStockLineItem(): ADL.ATypeExpr<PendingStockLineItem> {
  return {value : {typeRef : {kind: "reference", value : snPendingStockLineItem}, parameters : []}};
}

export interface PendingStockLineItemType_NewDealRequest {
  kind: 'newDealRequest';
  value: NewDealRequestLineItemData;
}
export interface PendingStockLineItemType_ResultOfProductionOrder {
  kind: 'resultOfProductionOrder';
  value: ProductionOrderLineItemData;
}

export type PendingStockLineItemType = PendingStockLineItemType_NewDealRequest | PendingStockLineItemType_ResultOfProductionOrder;

export interface PendingStockLineItemTypeOpts {
  newDealRequest: NewDealRequestLineItemData;
  resultOfProductionOrder: ProductionOrderLineItemData;
}

export function makePendingStockLineItemType<K extends keyof PendingStockLineItemTypeOpts>(kind: K, value: PendingStockLineItemTypeOpts[K]) { return {kind, value}; }

const PendingStockLineItemType_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"newDealRequest","default":{"kind":"nothing"},"name":"newDealRequest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"NewDealRequestLineItemData"}},"parameters":[]}},{"annotations":[],"serializedName":"resultOfProductionOrder","default":{"kind":"nothing"},"name":"resultOfProductionOrder","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"ProductionOrderLineItemData"}},"parameters":[]}}]}},"name":"PendingStockLineItemType","version":{"kind":"nothing"}}};

export const snPendingStockLineItemType: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"PendingStockLineItemType"};

export function texprPendingStockLineItemType(): ADL.ATypeExpr<PendingStockLineItemType> {
  return {value : {typeRef : {kind: "reference", value : snPendingStockLineItemType}, parameters : []}};
}

export interface DealTermsView {
  dealTerms: common_db.WithDbId<ferovinum_app_db.DealTerms>;
  additionalTerms: (common_strings.StringMD|null);
  masterAgreementDate: common.LocalDate;
}

export function makeDealTermsView(
  input: {
    dealTerms: common_db.WithDbId<ferovinum_app_db.DealTerms>,
    additionalTerms: (common_strings.StringMD|null),
    masterAgreementDate: common.LocalDate,
  }
): DealTermsView {
  return {
    dealTerms: input.dealTerms,
    additionalTerms: input.additionalTerms,
    masterAgreementDate: input.masterAgreementDate,
  };
}

const DealTermsView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"dealTerms","default":{"kind":"nothing"},"name":"dealTerms","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealTerms"}},"parameters":[]}]}},{"annotations":[],"serializedName":"additionalTerms","default":{"kind":"nothing"},"name":"additionalTerms","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringMD"}},"parameters":[]}]}},{"annotations":[],"serializedName":"masterAgreementDate","default":{"kind":"nothing"},"name":"masterAgreementDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}}]}},"name":"DealTermsView","version":{"kind":"nothing"}}};

export const snDealTermsView: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"DealTermsView"};

export function texprDealTermsView(): ADL.ATypeExpr<DealTermsView> {
  return {value : {typeRef : {kind: "reference", value : snDealTermsView}, parameters : []}};
}

export interface ContractNoteViewLineItem {
  product: ferovinum_app_db.Product;
  purchasePrice: ferovinum_app_types.Decimal;
  depositPrice: ferovinum_app_types.Decimal;
  totalNumberOfUnits: ferovinum_app_db.NumberOfUnits;
  numberOfFreeUnits: ferovinum_app_db.NumberOfUnits;
  compulsorySaleDate: common.LocalDate;
  compulsorySalePc: ferovinum_app_types.Decimal;
  finalDate: common.LocalDate;
  monthlyFee: (ferovinum_app_db.MonthlyFee|null);
  throughputFeePct: (ferovinum_app_types.Decimal|null);
  locationName: (string|null);
}

export function makeContractNoteViewLineItem(
  input: {
    product: ferovinum_app_db.Product,
    purchasePrice: ferovinum_app_types.Decimal,
    depositPrice: ferovinum_app_types.Decimal,
    totalNumberOfUnits: ferovinum_app_db.NumberOfUnits,
    numberOfFreeUnits: ferovinum_app_db.NumberOfUnits,
    compulsorySaleDate: common.LocalDate,
    compulsorySalePc: ferovinum_app_types.Decimal,
    finalDate: common.LocalDate,
    monthlyFee: (ferovinum_app_db.MonthlyFee|null),
    throughputFeePct: (ferovinum_app_types.Decimal|null),
    locationName: (string|null),
  }
): ContractNoteViewLineItem {
  return {
    product: input.product,
    purchasePrice: input.purchasePrice,
    depositPrice: input.depositPrice,
    totalNumberOfUnits: input.totalNumberOfUnits,
    numberOfFreeUnits: input.numberOfFreeUnits,
    compulsorySaleDate: input.compulsorySaleDate,
    compulsorySalePc: input.compulsorySalePc,
    finalDate: input.finalDate,
    monthlyFee: input.monthlyFee,
    throughputFeePct: input.throughputFeePct,
    locationName: input.locationName,
  };
}

const ContractNoteViewLineItem_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"product","default":{"kind":"nothing"},"name":"product","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Product"}},"parameters":[]}},{"annotations":[],"serializedName":"purchasePrice","default":{"kind":"nothing"},"name":"purchasePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}},{"annotations":[],"serializedName":"depositPrice","default":{"kind":"nothing"},"name":"depositPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}},{"annotations":[],"serializedName":"totalNumberOfUnits","default":{"kind":"nothing"},"name":"totalNumberOfUnits","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"numberOfFreeUnits","default":{"kind":"nothing"},"name":"numberOfFreeUnits","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"compulsorySaleDate","default":{"kind":"nothing"},"name":"compulsorySaleDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"compulsorySalePc","default":{"kind":"nothing"},"name":"compulsorySalePc","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}},{"annotations":[],"serializedName":"finalDate","default":{"kind":"nothing"},"name":"finalDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"monthlyFee","default":{"kind":"nothing"},"name":"monthlyFee","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"MonthlyFee"}},"parameters":[]}]}},{"annotations":[],"serializedName":"throughputFeePct","default":{"kind":"nothing"},"name":"throughputFeePct","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"locationName","default":{"kind":"nothing"},"name":"locationName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"ContractNoteViewLineItem","version":{"kind":"nothing"}}};

export const snContractNoteViewLineItem: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"ContractNoteViewLineItem"};

export function texprContractNoteViewLineItem(): ADL.ATypeExpr<ContractNoteViewLineItem> {
  return {value : {typeRef : {kind: "reference", value : snContractNoteViewLineItem}, parameters : []}};
}

export interface ContractNoteView {
  dealNumber: string;
  organisation: ferovinum_app_db.Organisation;
  dealCurrency: ferovinum_app_db.Currency;
  throughputFeePc: ferovinum_app_types.Decimal;
  monthlyFee: ferovinum_app_db.MonthlyFee;
  executionDate: common.LocalDate;
  startDate: common.LocalDate;
  endDate: common.LocalDate;
  masterAgreementSignedDate: common.LocalDate;
  dealTerms: ferovinum_app_db.DealTerms;
  additionalTermsText: common_strings.StringMD;
  grossTotal: ferovinum_app_types.Decimal;
  grossDepositTotal: ferovinum_app_types.Decimal;
  depositCreditTotal: ferovinum_app_types.Decimal;
  netAdvanceAmount: ferovinum_app_types.Decimal;
  attachedDocuments: ferovinum_app_uploads.AttachedDocument[];
  lineItems: ContractNoteViewLineItem[];
  feeInfoInLineItem: boolean;
  groupLineItemsByStorageInfo: boolean;
}

export function makeContractNoteView(
  input: {
    dealNumber: string,
    organisation: ferovinum_app_db.Organisation,
    dealCurrency: ferovinum_app_db.Currency,
    throughputFeePc: ferovinum_app_types.Decimal,
    monthlyFee: ferovinum_app_db.MonthlyFee,
    executionDate: common.LocalDate,
    startDate: common.LocalDate,
    endDate: common.LocalDate,
    masterAgreementSignedDate: common.LocalDate,
    dealTerms: ferovinum_app_db.DealTerms,
    additionalTermsText: common_strings.StringMD,
    grossTotal: ferovinum_app_types.Decimal,
    grossDepositTotal: ferovinum_app_types.Decimal,
    depositCreditTotal: ferovinum_app_types.Decimal,
    netAdvanceAmount: ferovinum_app_types.Decimal,
    attachedDocuments: ferovinum_app_uploads.AttachedDocument[],
    lineItems: ContractNoteViewLineItem[],
    feeInfoInLineItem: boolean,
    groupLineItemsByStorageInfo: boolean,
  }
): ContractNoteView {
  return {
    dealNumber: input.dealNumber,
    organisation: input.organisation,
    dealCurrency: input.dealCurrency,
    throughputFeePc: input.throughputFeePc,
    monthlyFee: input.monthlyFee,
    executionDate: input.executionDate,
    startDate: input.startDate,
    endDate: input.endDate,
    masterAgreementSignedDate: input.masterAgreementSignedDate,
    dealTerms: input.dealTerms,
    additionalTermsText: input.additionalTermsText,
    grossTotal: input.grossTotal,
    grossDepositTotal: input.grossDepositTotal,
    depositCreditTotal: input.depositCreditTotal,
    netAdvanceAmount: input.netAdvanceAmount,
    attachedDocuments: input.attachedDocuments,
    lineItems: input.lineItems,
    feeInfoInLineItem: input.feeInfoInLineItem,
    groupLineItemsByStorageInfo: input.groupLineItemsByStorageInfo,
  };
}

const ContractNoteView_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.views","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"dealNumber","default":{"kind":"nothing"},"name":"dealNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"organisation","default":{"kind":"nothing"},"name":"organisation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Organisation"}},"parameters":[]}},{"annotations":[],"serializedName":"dealCurrency","default":{"kind":"nothing"},"name":"dealCurrency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Currency"}},"parameters":[]}},{"annotations":[],"serializedName":"throughputFeePc","default":{"kind":"nothing"},"name":"throughputFeePc","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}},{"annotations":[],"serializedName":"monthlyFee","default":{"kind":"nothing"},"name":"monthlyFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"MonthlyFee"}},"parameters":[]}},{"annotations":[],"serializedName":"executionDate","default":{"kind":"nothing"},"name":"executionDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"startDate","default":{"kind":"nothing"},"name":"startDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"endDate","default":{"kind":"nothing"},"name":"endDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"masterAgreementSignedDate","default":{"kind":"nothing"},"name":"masterAgreementSignedDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"dealTerms","default":{"kind":"nothing"},"name":"dealTerms","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealTerms"}},"parameters":[]}},{"annotations":[],"serializedName":"additionalTermsText","default":{"kind":"nothing"},"name":"additionalTermsText","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringMD"}},"parameters":[]}},{"annotations":[],"serializedName":"grossTotal","default":{"kind":"nothing"},"name":"grossTotal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}},{"annotations":[],"serializedName":"grossDepositTotal","default":{"kind":"nothing"},"name":"grossDepositTotal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}},{"annotations":[],"serializedName":"depositCreditTotal","default":{"kind":"nothing"},"name":"depositCreditTotal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}},{"annotations":[],"serializedName":"netAdvanceAmount","default":{"kind":"nothing"},"name":"netAdvanceAmount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.types","name":"Decimal"}},"parameters":[]}},{"annotations":[],"serializedName":"attachedDocuments","default":{"kind":"nothing"},"name":"attachedDocuments","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.uploads","name":"AttachedDocument"}},"parameters":[]}]}},{"annotations":[],"serializedName":"lineItems","default":{"kind":"nothing"},"name":"lineItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.views","name":"ContractNoteViewLineItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"feeInfoInLineItem","default":{"kind":"nothing"},"name":"feeInfoInLineItem","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"groupLineItemsByStorageInfo","default":{"kind":"nothing"},"name":"groupLineItemsByStorageInfo","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"ContractNoteView","version":{"kind":"nothing"}}};

export const snContractNoteView: ADL.ScopedName = {moduleName:"ferovinum.app.views", name:"ContractNoteView"};

export function texprContractNoteView(): ADL.ATypeExpr<ContractNoteView> {
  return {value : {typeRef : {kind: "reference", value : snContractNoteView}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.views.CSVData" : CSVData_AST,
  "ferovinum.app.views.PurchasedStockCSV" : PurchasedStockCSV_AST,
  "ferovinum.app.views.PurchasedStockView" : PurchasedStockView_AST,
  "ferovinum.app.views.SoldStockCSV" : SoldStockCSV_AST,
  "ferovinum.app.views.SoldStockView" : SoldStockView_AST,
  "ferovinum.app.views.CapitalisedExpensesCSV" : CapitalisedExpensesCSV_AST,
  "ferovinum.app.views.CapitalisedExpensesView" : CapitalisedExpensesView_AST,
  "ferovinum.app.views.OrganisationAvailableStockViewCSV" : OrganisationAvailableStockViewCSV_AST,
  "ferovinum.app.views.OrganisationAvailableStockView" : OrganisationAvailableStockView_AST,
  "ferovinum.app.views.SinglesProductBalancesView" : SinglesProductBalancesView_AST,
  "ferovinum.app.views.NonSinglesProductBalancesView" : NonSinglesProductBalancesView_AST,
  "ferovinum.app.views.FSP" : FSP_AST,
  "ferovinum.app.views.ForwardSalePriceCalculationView" : ForwardSalePriceCalculationView_AST,
  "ferovinum.app.views.CapitalisedExpenseFspContributionView" : CapitalisedExpenseFspContributionView_AST,
  "ferovinum.app.views.ProductMovementReport" : ProductMovementReport_AST,
  "ferovinum.app.views.MinimalStorageLocationView" : MinimalStorageLocationView_AST,
  "ferovinum.app.views.ProductMovementTotals" : ProductMovementTotals_AST,
  "ferovinum.app.views.AvailableStockLineItem" : AvailableStockLineItem_AST,
  "ferovinum.app.views.AvailableStockLineItemType" : AvailableStockLineItemType_AST,
  "ferovinum.app.views.NegativeStockAdjustmentData" : NegativeStockAdjustmentData_AST,
  "ferovinum.app.views.DealLegLineItemData" : DealLegLineItemData_AST,
  "ferovinum.app.views.SaleOrderLineItemData" : SaleOrderLineItemData_AST,
  "ferovinum.app.views.ProductionOrderLineItemData" : ProductionOrderLineItemData_AST,
  "ferovinum.app.views.NewDealRequestLineItemData" : NewDealRequestLineItemData_AST,
  "ferovinum.app.views.StockMovementLineItemData" : StockMovementLineItemData_AST,
  "ferovinum.app.views.PurchaseRequestLineItemData" : PurchaseRequestLineItemData_AST,
  "ferovinum.app.views.PendingStockLineItem" : PendingStockLineItem_AST,
  "ferovinum.app.views.PendingStockLineItemType" : PendingStockLineItemType_AST,
  "ferovinum.app.views.DealTermsView" : DealTermsView_AST,
  "ferovinum.app.views.ContractNoteViewLineItem" : ContractNoteViewLineItem_AST,
  "ferovinum.app.views.ContractNoteView" : ContractNoteView_AST
};
